import { optimizely } from '../utils/optimizely/config';
import * as R from 'ramda';

// Default fallback maps translation keys to English labels
const defaultLabels = {
    'groupByOptions.date': 'Date',
    'groupByOptions.rightsholder': 'Rightsholder',
    'groupByOptions.sponsor': 'Sponsor',
    'groupByOptions.rightsholderPlacement': 'Placement',
    'groupByOptions.socialPlatform': 'Platform',
    'groupByOptions.gameName': 'Event',
    'groupByOptions.mediaUploadName': 'Broadcast Name',
    'groupByOptions.account': 'Account',
    'groupByOptions.socialAccountGroup': 'Social Account Group',
    'groupByOptions.accountOwnershipType': 'Account Type',
    'groupByOptions.mediaType': 'Media Type',
    'groupByOptions.postType': 'Post Type',
    'groupByOptions.authorshipType': 'Authorship Type',
    'groupByOptions.collaboratingAccounts': 'Collaborating Accounts',
};

/**
 * @param {Function} t - Translation function (i18next t function or custom)
 */
const getGroupByOptions = async t => {
    // Use default labels if no translation function provided
    const translate = t || (key => defaultLabels[key] || key);
    const isGroupByNameEnabled = await optimizely
        .onReady()
        .then(() => optimizely.isFeatureEnabled('group_by_game'));
    return [
        {
            label: translate('groupByOptions.date'),
            value: 'date',
        },
        {
            label: translate('groupByOptions.rightsholder'),
            value: 'rightsholder',
        },
        {
            label: translate('groupByOptions.sponsor'),
            value: 'sponsor',
        },
        {
            label: translate('groupByOptions.rightsholderPlacement'),
            value: 'rightsholderPlacement',
        },
        {
            label: translate('groupByOptions.socialPlatform'),
            value: 'socialPlatform',
        },
        isGroupByNameEnabled
            ? {
                  label: translate('groupByOptions.gameName'),
                  value: 'gameName',
              }
            : {
                  label: translate('groupByOptions.mediaUploadName'),
                  value: 'mediaUploadName',
              },
        {
            label: translate('groupByOptions.account'),
            value: 'account',
        },
        {
            label: translate('groupByOptions.socialAccountGroup'),
            value: 'socialAccountGroup',
        },
        {
            label: translate('groupByOptions.accountOwnershipType'),
            value: 'accountOwnershipType',
        },
        {
            label: translate('groupByOptions.mediaType'),
            value: 'mediaType',
        },
        {
            label: translate('groupByOptions.postType'),
            value: 'postType',
        },
        {
            label: translate('groupByOptions.authorshipType'),
            value: 'authorshipType',
        },
        {
            label: translate('groupByOptions.collaboratingAccounts'),
            value: 'collaboratingAccounts',
        },
    ].filter(R.identity);
};

export default getGroupByOptions;
